import Vue from 'vue';
import { DateTime } from 'luxon';
import humanize from './humanize';
import hoursAndMinutes from './hoursAndMinutes';
import formatMinutes from './formatMinutes';
import hourOfDay from './hourOfDay';

const dateFormat = 'MMMM d, yyyy';
const shortDateFormat = 'M/d/yyyy';

Vue.filter('formatDate', value => DateTime.fromISO(String(value)).toFormat(dateFormat));
Vue.filter('formatDateShort', value => DateTime.fromISO(String(value)).toFormat(shortDateFormat));
Vue.filter('formatJobDate', value => DateTime.fromFormat(String(value), 'yyyyMMdd').toFormat(dateFormat));
Vue.filter('formatJobDateShort', value => DateTime.fromFormat(String(value), 'yyyyMMdd').toFormat(shortDateFormat));

Vue.filter('numberToAmPm', hourOfDay);

Vue.filter('humanize', humanize);
Vue.filter('hoursAndMinutes', hoursAndMinutes);
Vue.filter('formatMinutes', formatMinutes);

Vue.filter('phoneNumber', (value) => {
  let phone = value;
  const displayMode = 'noParens';
  if (!phone || !phone.substr) {
    return phone;
  }

  if (phone.startsWith('+1')) {
    phone = phone.substr(2);
  }

  if (phone.length !== 10) {
    return phone;
  }

  let areaCodeComponent;

  if (displayMode === 'noParens') {
    areaCodeComponent = `${phone.substr(0, 3)}-`;
  } else {
    areaCodeComponent = `(${phone.substr(0, 3)}) `;
  }

  return `${areaCodeComponent}${phone.substr(3, 3)}-${phone.substr(6, 4)}`;
});

Vue.filter('currency', (value) => {
  if (typeof value !== 'number') {
    return value;
  }

  if (value < 0) {
    return `-$${Math.abs(value).toFixed(2)}`;
  }

  return `$${value.toFixed(2)}`;
});
